<div #echarts class="chart"></div>
